import Select from "react-select";
import { AppMode } from "../../../globalState/reducers/Theme.reducer";
import useTheme from "../../../Services/Hooks/useTheme";

interface SelectInputProps {
    id?: string;
    options: any;
    components?: any;
    className?: string;
    value?: any;
    onChange?: (value: any) => void;
    required?: boolean;
    defaultValue?: any;
    isMulti?: boolean;
}

const SelectInput = ({
    id,
    options,
    components,
    value,
    onChange,
    required,
    defaultValue,
    isMulti,
}: SelectInputProps) => {
    const { mode } = useTheme();
    return (
        <Select
            id={id}
            options={options}
            components={components}
            value={value}
            onChange={onChange}
            styles={{
                control: (base) =>
                    mode === AppMode.LIGHT
                        ? {
                              ...base,
                              minHeight: 46,
                              borderRadius: "0.5rem",
                              "&:hover": {
                                  borderColor: "#263238",
                              },
                              borderColor: "#263238",
                              background: "#263238",
                              color: "#fff",
                              paddingLeft: 30,
                              boxShadow: "transparent",
                          }
                        : {
                              ...base,
                              minHeight: 46,
                              borderRadius: "0.5rem",
                              borderColor: "#263238",
                              "&:hover": {
                                  borderColor: "#263238",
                              },
                              boxShadow: "transparent",
                              background: "#263238",
                              color: "#fff",
                              paddingLeft: 30,
                          },
                option: (base) =>
                    mode === AppMode.LIGHT
                        ? {
                              ...base,
                              minHeight: 46,
                              background: "#313738",
                              color: "#fff",
                              "&:hover": {
                                  color: "#fff",
                                  background: "#fc9828",
                              },
                          }
                        : {
                              ...base,
                              minHeight: 46,
                              background: "#313738",
                              color: "#FFF",
                              "&:hover": {
                                  color: "#fff",
                                  background: "#fc9828",
                              },
                          },
            }}
            required={!!required}
            defaultValue={defaultValue}
            isMulti={!!isMulti}
        />
    );
};

export default SelectInput;
